import type { PickedPhoto } from 'components/PhotoBank/PhotoBank.types'

export enum GooglePhotosStatus {
  AUTHENTICATING = 'authenticating',
  AUTHENTICATED = 'authenticated',
  CREATING_SESSION = 'creating_session',
  CHOOSING_IMAGES = 'choosing_images',
  FETCHING_IMAGES = 'fetching_images',
}

export interface PollingConfig {
  nextPollInSeconds: number
}

export interface PickingConfig {
  maxItemCount: string
}

export interface GooglePhotosSession {
  id: string
  pickerUri: string
  pollingConfig?: PollingConfig
  expireTime?: string
  pickingConfig?: PickingConfig
  mediaItemsSet?: boolean
  // Legacy field for backward compatibility
  pollingPolicy?: {
    nextPollInSeconds: number
  }
}

export interface GooglePhotosMediaItem {
  mediaFile: {
    baseUrl: string
    filename: string
  }
}

export interface GooglePhotosAuthConfig {
  clientId: string
}

export interface GooglePhotosPickingOptions {
  singleFileOnly?: boolean
}

export interface UseGooglePhotosReturn {
  startPhotoPicking: (
    config: GooglePhotosAuthConfig,
    options?: GooglePhotosPickingOptions,
    onAuthSuccess?: () => Promise<void>
  ) => Promise<PickedPhoto[]>
  proceedWithPendingPicking: () => Promise<void>
  setCompletionCallback: (callback: (photos: PickedPhoto[]) => void) => void
  status: GooglePhotosStatus | null
  error: string | null
  hasToken: boolean
  hasPendingPicking: boolean
  reset: () => void
}
